import { ref } from 'vue'

export enum BackgroundThemes {
  START = 'start',
  REST = 'rest',
  WORK = 'work',
  FINAL = 'final',
}

const backgroundTheme = ref<BackgroundThemes>(BackgroundThemes.START)

export function useBackground () {
  return {
    backgroundTheme
  }
}
